import React from 'react';

import PropTypes from 'prop-types';

const FieldHint = ({ hint }) => {
    if (!hint) return null;

    return (
        <div className="form-text text-muted">
            { hint }
        </div>
    );
};

FieldHint.propTypes = {
    hint: PropTypes.string,
};

export default FieldHint;
